<template>
  <div>
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" size="small" placeholder=""
                  prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="search()"/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>
      </div>

    </div>
    <el-table :data="commentData" v-loading="loading" :header-cell-style="{ background: '#F5F7FA' }"
              style="width: 100%; margin-bottom: 20px" border>
      <el-table-column type="expand">
        <template #default="scope">
          <el-table v-if="scope.row.commentFileList.length > 0" :data="scope.row.commentFileList">
            <el-table-column prop="liveCommentFileId" label="#" align="center"></el-table-column>
            <el-table-column label="文件">
              <template #default="scope">
                <div style="width: 100px; height: 100px;position: relative">
                  <el-image style="width: 100px; height: 100px;" fit="scale-down"
                            :src="getPreviewImageUrl(scope.row)" lazy :preview-src-list="[getPreviewImageUrl(scope.row)]"
                            :close-on-click-modal="true">
                    <template #error>
                      <p></p>
                    </template>
                  </el-image>
                  <i class="el-icon-video-play"
                     v-if="scope.row.fileType === 1"
                     style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: black;"
                     @click.stop="previewVideo(scope.row.fileUrl)"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="liveCommentFileId" label="上传时间" align="center">
              <template #default="scope">
                {{ scope.row.createTime | formatDateTime }}
              </template>
            </el-table-column>
          </el-table>
          <p v-else>没有文件数据</p>
        </template>
      </el-table-column>
      <el-table-column align="center" property="liveCommentId" label="#"/>
      <el-table-column align="center" property="nickname" label="回复者" show-overflow-tooltip>
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column align="center" property="content" label="内容"/>
      <el-table-column align="center" property="replyCount" label="回复数"/>
      <el-table-column align="center" property="likeCount" label="点赞数"/>
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <el-button type="primary" size="small" @click="viewReply(scope.row)">查看回复</el-button>
          <el-button size="small" :type="scope.row.isDeleted ? 'warning' : 'danger'"
                     @click="handleDeleteComment(scope.row)">
            {{ scope.row.isDeleted ? "恢复" : "删除" }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="commentTotalCount" :page-size="commentPageSize"
                   :current-page="commentCurrentPage" @current-change="commentCurrentChange"/>

    <el-dialog :visible.sync="replyDlg" :close-on-click-modal="false">
      <div class="topbar">
        <div>
          <el-input v-model="replySearchValue" size="small" placeholder=""
                    prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="replySearch()"/>
          <el-button type="primary" icon="el-icon-search" size="small" :disabled="!replySearchValue"
                     @click.stop="replySearch()">
            搜索
          </el-button>
        </div>

      </div>
      <el-table :data="replyData" v-loading="replyLoading" :header-cell-style="{ background: '#F5F7FA' }"
                style="width: 100%; margin-bottom: 20px;height: 60vh;overflow: auto" border>
        <el-table-column type="expand">
          <template #default="scope">
            <el-table v-if="scope.row.commentFileList.length > 0" :data="scope.row.commentFileList">
              <el-table-column prop="liveCommentFileId" label="#" align="center"></el-table-column>
              <el-table-column label="文件">
                <template #default="scope">
                  <div style="width: 100px; height: 100px;position: relative">
                    <el-image style="width: 100px; height: 100px;" fit="scale-down"
                              :src="getPreviewImageUrl(scope.row)" lazy :preview-src-list="[getPreviewImageUrl(scope.row)]"
                              :close-on-click-modal="true">
                      <template #error>
                        <p></p>
                      </template>
                    </el-image>
                    <i class="el-icon-video-play"
                       v-if="scope.row.fileType === 1"
                       style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: black;"
                       @click.stop="previewVideo(scope.row.fileUrl)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="liveCommentFileId" label="上传时间" align="center">
                <template #default="scope">
                  {{ scope.row.createTime | formatDateTime }}
                </template>
              </el-table-column>
            </el-table>
            <p v-else>没有文件数据</p>
          </template>
        </el-table-column>
        <el-table-column align="center" property="liveCommentId" label="#"/>
        <el-table-column align="center" property="nickname" label="回复者" show-overflow-tooltip>
          <template #default="scope">
            <user-info :user="scope.row"></user-info>
          </template>
        </el-table-column>
        <el-table-column align="center" property="content" label="内容"/>
        <el-table-column align="center" property="replyCount" label="回复数"/>
        <el-table-column align="center" property="likeCount" label="点赞数"/>
        <el-table-column align="center" label="操作">
          <template #default="scope">
            <el-button size="small" :type="scope.row.isDeleted ? 'warning' : 'danger'"
                       @click="handleDeleteRelyComment(scope.row)">
              {{ scope.row.isDeleted ? "恢复" : "删除" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="replyPageOpt.totalCount"
                     :page-size="replyPageOpt.pageSize"
                     :current-page="replyPageOpt.curPage" @current-change="replyCommentCurrentChange"/>
    </el-dialog>

    <!-- 预览视频 -->
    <el-dialog title="查看视频" :visible.sync="previewVideoDialog" width="60%" :destroy-on-close='true'>
      <tx-video-player style="height: 60vh" :videoUrl="previewVideoPath"></tx-video-player>
    </el-dialog>
  </div>

</template>

<script>
import {getCommentList, liveCommentDeleteOrBack, getReplyLiveCommentList} from "@/api/mai/liveReviews/liveReviews";
import {handleRes} from "@/utils/handleRes";
import {getCloudUrl, getPreviewImgUrl} from "@/utils/urlutil";
import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import UserInfo from "@/components/UserInfo/UserInfo";

export default {
  name: "replayList",
  props: {
    liveID: {
      Number
    }
  },
  components:{
    UserInfo,
    TxVideoPlayer
  },
  data() {
    return {
      loading: false,
      searchValue: "",
      commentData: [], // 回复表格数
      commentTotalCount: 0, // 列表总数
      commentPageSize: 10, // 单页条数
      commentCurrentPage: 1, // 当前页码

      replyLoading: false,
      relativeCommentId: 0,
      replySearchValue: "",
      replyDlg: false,
      replyData: [],
      replyPageOpt: {
        totalCount: 0,
        curPage: 1,
        pageSize: 10
      },

      previewVideoPath: "",
      previewVideoDialog: false,
    }
  },
  created() {
    this.getCommentList()
  },
  methods: {
    getPreviewImageUrl(entity){
      return getPreviewImgUrl(entity)
    },
    previewVideo(fileUrl) {
      this.previewVideoPath = getCloudUrl(fileUrl)
      this.previewVideoDialog = true
    },
    search() {
      this.commentCurrentPage = 1;
      this.getCommentList()
    },
    commentCurrentChange(currentPage) {
      this.commentCurrentPage = currentPage
      this.getCommentList()
    },
    getCommentList() {
      const params = {
        keyWord: this.searchValue,
        liveId: this.liveID,
        pageNumber: this.commentCurrentPage,
      };
      this.loading = true
      getCommentList(params).then((res) => {
        handleRes(res, () => {
          this.commentData = res.data.rows;
          this.commentTotalCount = res.data.total;
        })
        this.utils.stopLoading(this)
      });
    },
    handleDeleteComment(entity) {
      liveCommentDeleteOrBack({
        liveCommentId: entity.liveCommentId
      }).then(res => {
        handleRes(res, () => {
          this.getCommentList()
        })
      })
    },

    /**
     * 查看评论回复
     * @param entity
     */
    viewReply(entity) {
      this.relativeCommentId = entity.liveCommentId
      this.replyData = []
      this.getReplyLiveCommentList()
      this.replyDlg = true
    },
    replySearch() {
      this.replyPageOpt.curPage = 1
      this.getReplyLiveCommentList()
    },
    getReplyLiveCommentList() {
      let params = {
        keyWord: this.replySearchValue,
        liveId: this.liveID,
        pageNumber: this.replyPageOpt.curPage,
        pageSize: this.replyPageOpt.pageSize,
        relativeCommentId: this.relativeCommentId
      }
      this.replyLoading = true;
      getReplyLiveCommentList(params).then((res) => {
        handleRes(res, () => {
          this.replyData = res.data.rows
          this.replyPageOpt.totalCount = res.data.total
        })
        this.replyLoading = false
      })
    },
    replyCommentCurrentChange(curPage) {
      this.replyPageOpt.curPage = curPage
    },
    handleDeleteRelyComment(entity) {
      liveCommentDeleteOrBack({
        liveCommentId: entity.liveCommentId
      }).then(res => {
        handleRes(res, () => {
          this.getReplyLiveCommentList()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>